$( function() {
	handleSticky();
});

function handleSticky() {
	var toppx = $('.site-header').outerHeight();
	if (window.innerWidth > 991) {
		var toppx = $('.site-header').outerHeight();
	}

	$(window).on('scroll', function() {
		var distance = $('.go-to-anchors').offset().top - $('.site-header').outerHeight();

		var toppx = $('.site-header').outerHeight();

		if ($('#wpadminbar').is(":visible") && window.innerWidth > 1169) {
				var toppx = $('.site-header').outerHeight() + 28;
		}

		if ( $(this).scrollTop() >= distance ) {
			$('.go-to-anchors').css('height', $('.go-to-anchors .wrap').outerHeight()+'px');
			$('.go-to-anchors .wrap').addClass('sticky').css('top', toppx+'px');
		} else {
			$('.go-to-anchors').css('height', '');
			$('.go-to-anchors .wrap').removeClass('sticky').css('top', '');
		}
	});


	//The scroll to click function
	$('.go-to-anchors a[href^="#"]').on('click', function(e) {
		e.preventDefault();
		$('.go-to-anchors a[href^="#"]').not($(this)).removeClass('active');
		$(this).addClass('active');
		if ($(this).attr('href').length > 1) $('html, body').stop().animate({'scrollTop': $(this.hash).offset().top - 200}, 1300);
	});

}